<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" role="doc-toc">
<h1 id="toc-title">Insurrection</h1>
<ol class="toc">
<li>
<span href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li id="title_page">
<a href="#/text/title_page">Title Page</a>
</li>
<li id="toc-li-1">
<a href="#/text/ch001#prologue">Prologue</a>
<ol class="toc">
<li id="toc-li-2">
<a href="#/text/ch001#present-day">Present day</a>
<ol class="toc">
<li id="toc-li-3">
<a href="#/text/ch001#vicinity-of-hamidiyah-syria">Vicinity of Hamidiyah, Syria</a>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-4">
<a href="#/text/ch002#chapter-1">Chapter 1</a>
<ol class="toc">
<li id="toc-li-5">
<a href="#/text/ch002#himachal-pradesh-district-india">Himachal Pradesh district, India</a>
</li>
</ol>
</li>
<li id="toc-li-6">
<a href="#/text/ch003#chapter-2">Chapter 2</a>
<ol class="toc">
<li id="toc-li-7">
<a href="#/text/ch003#hammersmith-london">Hammersmith, London</a>
</li>
</ol>
</li>
<li id="toc-li-8">
<span href="#/text/ch004#chapter-3" title="Link target outside of Sample">Chapter 3</span>
<ol class="toc">
<li id="toc-li-9">
<span href="#/text/ch004#denver-colorado" title="Link target outside of Sample">Denver, Colorado</span>
</li>
</ol>
</li>
<li id="toc-li-10">
<span href="#/text/ch005#chapter-4" title="Link target outside of Sample">Chapter 4</span>
<ol class="toc">
<li id="toc-li-11">
<span href="#/text/ch005#hammersmith-london-1" title="Link target outside of Sample">Hammersmith, London</span>
</li>
</ol>
</li>
<li id="toc-li-12">
<span href="#/text/ch006#chapter-5" title="Link target outside of Sample">Chapter 5</span>
<ol class="toc">
<li id="toc-li-13">
<span href="#/text/ch006#denver-colorado-1" title="Link target outside of Sample">Denver, Colorado</span>
</li>
</ol>
</li>
<li id="toc-li-14">
<span href="#/text/ch007#chapter-6" title="Link target outside of Sample">Chapter 6</span>
<ol class="toc">
<li id="toc-li-15">
<span href="#/text/ch007#hammersmith-london-2" title="Link target outside of Sample">Hammersmith, London</span>
</li>
</ol>
</li>
<li id="toc-li-16">
<span href="#/text/ch008#chapter-7" title="Link target outside of Sample">Chapter 7</span>
<ol class="toc">
<li id="toc-li-17">
<span href="#/text/ch008#quetta-pakistan" title="Link target outside of Sample">Quetta, Pakistan</span>
</li>
</ol>
</li>
<li id="toc-li-18">
<span href="#/text/ch009#chapter-8" title="Link target outside of Sample">Chapter 8</span>
<ol class="toc">
<li id="toc-li-19">
<span href="#/text/ch009#hammersmith-london-3" title="Link target outside of Sample">Hammersmith, London</span>
</li>
</ol>
</li>
<li id="toc-li-20">
<span href="#/text/ch010#chapter-9" title="Link target outside of Sample">Chapter 9</span>
<ol class="toc">
<li id="toc-li-21">
<span href="#/text/ch010#denver-colorado-2" title="Link target outside of Sample">Denver, Colorado</span>
</li>
</ol>
</li>
<li id="toc-li-22">
<span href="#/text/ch011#chapter-10" title="Link target outside of Sample">Chapter 10</span>
<ol class="toc">
<li id="toc-li-23">
<span href="#/text/ch011#hammersmith-london-4" title="Link target outside of Sample">Hammersmith, London</span>
</li>
</ol>
</li>
<li id="toc-li-24">
<span href="#/text/ch012#chapter-11" title="Link target outside of Sample">Chapter 11</span>
<ol class="toc">
<li id="toc-li-25">
<span href="#/text/ch012#denver-colorado-3" title="Link target outside of Sample">Denver, Colorado</span>
</li>
</ol>
</li>
<li id="toc-li-26">
<span href="#/text/ch013#chapter-12" title="Link target outside of Sample">Chapter 12</span>
<ol class="toc">
<li id="toc-li-27">
<span href="#/text/ch013#hammersmith-london-5" title="Link target outside of Sample">Hammersmith, London</span>
</li>
</ol>
</li>
<li id="toc-li-28">
<span href="#/text/ch014#chapter-13" title="Link target outside of Sample">Chapter 13</span>
<ol class="toc">
<li id="toc-li-29">
<span href="#/text/ch014#himachal-pradesh-district-india-1" title="Link target outside of Sample">Himachal Pradesh district, India</span>
</li>
</ol>
</li>
<li id="toc-li-30">
<span href="#/text/ch015#chapter-14" title="Link target outside of Sample">Chapter 14</span>
<ol class="toc">
<li id="toc-li-31">
<span href="#/text/ch015#raf-northolt-west-london" title="Link target outside of Sample">RAF Northolt, west London</span>
</li>
</ol>
</li>
<li id="toc-li-32">
<span href="#/text/ch016#chapter-15" title="Link target outside of Sample">Chapter 15</span>
<ol class="toc">
<li id="toc-li-33">
<span href="#/text/ch016#himachal-pradesh-district-india-2" title="Link target outside of Sample">Himachal Pradesh district, India</span>
</li>
</ol>
</li>
<li id="toc-li-34">
<span href="#/text/ch017#chapter-16" title="Link target outside of Sample">Chapter 16</span>
<ol class="toc">
<li id="toc-li-35">
<span href="#/text/ch017#c-130-hercules-call-sign-whisky-tango-23" title="Link target outside of Sample">C-130 Hercules, call sign Whisky Tango 23</span>
<ol class="toc">
<li id="toc-li-36">
<span href="#/text/ch017#eastern-mediterranean" title="Link target outside of Sample">Eastern Mediterranean</span>
</li>
</ol>
</li>
</ol>
</li>
<li id="toc-li-37">
<span href="#/text/ch018#chapter-17" title="Link target outside of Sample">Chapter 17</span>
<ol class="toc">
<li id="toc-li-38">
<span href="#/text/ch018#quetta-pakistan-1" title="Link target outside of Sample">Quetta, Pakistan</span>
</li>
</ol>
</li>
<li id="toc-li-39">
<span href="#/text/ch019#chapter-18" title="Link target outside of Sample">Chapter 18</span>
<ol class="toc">
<li id="toc-li-40">
<span href="#/text/ch019#raf-akrotiri-cyprus" title="Link target outside of Sample">RAF Akrotiri, Cyprus</span>
</li>
</ol>
</li>
<li id="toc-li-41">
<span href="#/text/ch020#chapter-19" title="Link target outside of Sample">Chapter 19</span>
<ol class="toc">
<li id="toc-li-42">
<span href="#/text/ch020#denver-colorado-4" title="Link target outside of Sample">Denver, Colorado</span>
</li>
</ol>
</li>
<li id="toc-li-43">
<span href="#/text/ch021#chapter-20" title="Link target outside of Sample">Chapter 20</span>
<ol class="toc">
<li id="toc-li-44">
<span href="#/text/ch021#raf-akrotiri-cyprus-1" title="Link target outside of Sample">RAF Akrotiri, Cyprus</span>
</li>
</ol>
</li>
<li id="toc-li-45">
<span href="#/text/ch022#chapter-21" title="Link target outside of Sample">Chapter 21</span>
<ol class="toc">
<li id="toc-li-46">
<span href="#/text/ch022#quetta-pakistan-2" title="Link target outside of Sample">Quetta, Pakistan</span>
</li>
</ol>
</li>
<li id="toc-li-47">
<span href="#/text/ch023#chapter-22" title="Link target outside of Sample">Chapter 22</span>
<ol class="toc">
<li id="toc-li-48">
<span href="#/text/ch023#denver-colorado-5" title="Link target outside of Sample">Denver, Colorado</span>
</li>
</ol>
</li>
<li id="toc-li-49">
<span href="#/text/ch024#chapter-23" title="Link target outside of Sample">Chapter 23</span>
<ol class="toc">
<li id="toc-li-50">
<span href="#/text/ch024#raf-akrotiri-cyprus-2" title="Link target outside of Sample">RAF Akrotiri, Cyprus</span>
</li>
</ol>
</li>
<li id="toc-li-51">
<span href="#/text/ch025#chapter-24" title="Link target outside of Sample">Chapter 24</span>
<ol class="toc">
<li id="toc-li-52">
<span href="#/text/ch025#dakar-senegal" title="Link target outside of Sample">Dakar, Senegal</span>
</li>
</ol>
</li>
<li id="toc-li-53">
<span href="#/text/ch026#chapter-25" title="Link target outside of Sample">Chapter 25</span>
<ol class="toc">
<li id="toc-li-54">
<span href="#/text/ch026#new-delhi-india" title="Link target outside of Sample">New Delhi, India</span>
</li>
</ol>
</li>
<li id="toc-li-55">
<span href="#/text/ch027#chapter-26" title="Link target outside of Sample">Chapter 26</span>
<ol class="toc">
<li id="toc-li-56">
<span href="#/text/ch027#denver-colorado-6" title="Link target outside of Sample">Denver, Colorado</span>
</li>
</ol>
</li>
<li id="toc-li-57">
<span href="#/text/ch028#chapter-27" title="Link target outside of Sample">Chapter 27</span>
<ol class="toc">
<li id="toc-li-58">
<span href="#/text/ch028#vicinity-of-homs-syria" title="Link target outside of Sample">Vicinity of Homs, Syria</span>
</li>
</ol>
</li>
<li id="toc-li-59">
<span href="#/text/ch029#chapter-28" title="Link target outside of Sample">Chapter 28</span>
<ol class="toc">
<li id="toc-li-60">
<span href="#/text/ch029#denver-colorado-7" title="Link target outside of Sample">Denver, Colorado</span>
</li>
</ol>
</li>
<li id="toc-li-61">
<span href="#/text/ch030#chapter-29" title="Link target outside of Sample">Chapter 29</span>
<ol class="toc">
<li id="toc-li-62">
<span href="#/text/ch030#vicinity-of-homs-syria-1" title="Link target outside of Sample">Vicinity of Homs, Syria</span>
</li>
</ol>
</li>
<li id="toc-li-63">
<span href="#/text/ch031#chapter-30" title="Link target outside of Sample">Chapter 30</span>
<ol class="toc">
<li id="toc-li-64">
<span href="#/text/ch031#new-york-new-york" title="Link target outside of Sample">New York, New York</span>
</li>
</ol>
</li>
<li id="toc-li-65">
<span href="#/text/ch032#chapter-31" title="Link target outside of Sample">Chapter 31</span>
<ol class="toc">
<li id="toc-li-66">
<span href="#/text/ch032#vicinity-of-homs-syria-2" title="Link target outside of Sample">Vicinity of Homs, Syria</span>
</li>
</ol>
</li>
<li id="toc-li-67">
<span href="#/text/ch033#chapter-32" title="Link target outside of Sample">Chapter 32</span>
<ol class="toc">
<li id="toc-li-68">
<span href="#/text/ch033#denver-colorado-8" title="Link target outside of Sample">Denver, Colorado</span>
</li>
</ol>
</li>
<li id="toc-li-69">
<span href="#/text/ch034#chapter-33" title="Link target outside of Sample">Chapter 33</span>
<ol class="toc">
<li id="toc-li-70">
<span href="#/text/ch034#vicinity-of-homs-syria-3" title="Link target outside of Sample">Vicinity of Homs, Syria</span>
</li>
</ol>
</li>
<li id="toc-li-71">
<span href="#/text/ch035#chapter-34" title="Link target outside of Sample">Chapter 34</span>
<ol class="toc">
<li id="toc-li-72">
<span href="#/text/ch035#hammersmith-london-6" title="Link target outside of Sample">Hammersmith, London</span>
</li>
</ol>
</li>
<li id="toc-li-73">
<span href="#/text/ch036#chapter-35" title="Link target outside of Sample">Chapter 35</span>
<ol class="toc">
<li id="toc-li-74">
<span href="#/text/ch036#vicinity-of-homs-syria-4" title="Link target outside of Sample">Vicinity of Homs, Syria</span>
</li>
</ol>
</li>
<li id="toc-li-75">
<span href="#/text/ch037#chapter-36" title="Link target outside of Sample">Chapter 36</span>
<ol class="toc">
<li id="toc-li-76">
<span href="#/text/ch037#savannah-georgia" title="Link target outside of Sample">Savannah, Georgia</span>
</li>
</ol>
</li>
<li id="toc-li-77">
<span href="#/text/ch038#chapter-37" title="Link target outside of Sample">Chapter 37</span>
<ol class="toc">
<li id="toc-li-78">
<span href="#/text/ch038#vicinity-of-homs-syria-5" title="Link target outside of Sample">Vicinity of Homs, Syria</span>
</li>
</ol>
</li>
<li id="toc-li-79">
<span href="#/text/ch039#chapter-38" title="Link target outside of Sample">Chapter 38</span>
<ol class="toc">
<li id="toc-li-80">
<span href="#/text/ch039#j.-edgar-hoover-building-washington-dc" title="Link target outside of Sample">J. Edgar Hoover Building, Washington, DC</span>
</li>
</ol>
</li>
<li id="toc-li-81">
<span href="#/text/ch040#chapter-39" title="Link target outside of Sample">Chapter 39</span>
<ol class="toc">
<li id="toc-li-82">
<span href="#/text/ch040#vicinity-of-homs-syria-6" title="Link target outside of Sample">Vicinity of Homs, Syria</span>
</li>
</ol>
</li>
<li id="toc-li-83">
<span href="#/text/ch041#chapter-40" title="Link target outside of Sample">Chapter 40</span>
<ol class="toc">
<li id="toc-li-84">
<span href="#/text/ch041#savannah-georgia-1" title="Link target outside of Sample">Savannah, Georgia</span>
</li>
</ol>
</li>
<li id="toc-li-85">
<span href="#/text/ch042#chapter-41" title="Link target outside of Sample">Chapter 41</span>
<ol class="toc">
<li id="toc-li-86">
<span href="#/text/ch042#hammersmith-london-7" title="Link target outside of Sample">Hammersmith, London</span>
</li>
</ol>
</li>
<li id="toc-li-87">
<span href="#/text/ch043#chapter-42" title="Link target outside of Sample">Chapter 42</span>
<ol class="toc">
<li id="toc-li-88">
<span href="#/text/ch043#in-transit" title="Link target outside of Sample">In transit</span>
</li>
</ol>
</li>
<li id="toc-li-89">
<span href="#/text/ch044#chapter-43" title="Link target outside of Sample">Chapter 43</span>
<ol class="toc">
<li id="toc-li-90">
<span href="#/text/ch044#new-york-new-york-1" title="Link target outside of Sample">New York, New York</span>
</li>
</ol>
</li>
<li id="toc-li-91">
<span href="#/text/ch045#chapter-44" title="Link target outside of Sample">Chapter 44</span>
<ol class="toc">
<li id="toc-li-92">
<span href="#/text/ch045#savannah-georgia-2" title="Link target outside of Sample">Savannah, Georgia</span>
</li>
</ol>
</li>
<li id="toc-li-93">
<span href="#/text/ch046#chapter-45" title="Link target outside of Sample">Chapter 45</span>
<ol class="toc">
<li id="toc-li-94">
<span href="#/text/ch046#new-york-new-york-2" title="Link target outside of Sample">New York, New York</span>
</li>
</ol>
</li>
<li id="toc-li-95">
<span href="#/text/ch047#chapter-46" title="Link target outside of Sample">Chapter 46</span>
<ol class="toc">
<li id="toc-li-96">
<span href="#/text/ch047#hammersmith-london-8" title="Link target outside of Sample">Hammersmith, London</span>
</li>
</ol>
</li>
<li id="toc-li-97">
<span href="#/text/ch048#chapter-47" title="Link target outside of Sample">Chapter 47</span>
<ol class="toc">
<li id="toc-li-98">
<span href="#/text/ch048#new-york-new-york-3" title="Link target outside of Sample">New York, New York</span>
</li>
</ol>
</li>
<li id="toc-li-99">
<span href="#/text/ch049#chapter-48" title="Link target outside of Sample">Chapter 48</span>
<ol class="toc">
<li id="toc-li-100">
<span href="#/text/ch049#eastern-seaboard" title="Link target outside of Sample">Eastern seaboard</span>
</li>
</ol>
</li>
<li id="toc-li-101">
<span href="#/text/ch050#chapter-49" title="Link target outside of Sample">Chapter 49</span>
<ol class="toc">
<li id="toc-li-102">
<span href="#/text/ch050#savannah-georgia-3" title="Link target outside of Sample">Savannah, Georgia</span>
</li>
</ol>
</li>
<li id="toc-li-103">
<span href="#/text/ch051#chapter-50" title="Link target outside of Sample">Chapter 50</span>
<ol class="toc">
<li id="toc-li-104">
<span href="#/text/ch051#new-york-new-york-4" title="Link target outside of Sample">New York, New York</span>
</li>
</ol>
</li>
<li id="toc-li-105">
<span href="#/text/ch052#chapter-51" title="Link target outside of Sample">Chapter 51</span>
<ol class="toc">
<li id="toc-li-106">
<span href="#/text/ch052#savannah-georgia-4" title="Link target outside of Sample">Savannah, Georgia</span>
</li>
</ol>
</li>
<li id="toc-li-107">
<span href="#/text/ch053#chapter-52" title="Link target outside of Sample">Chapter 52</span>
<ol class="toc">
<li id="toc-li-108">
<span href="#/text/ch053#boston-massachusetts" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-109">
<span href="#/text/ch054#chapter-53" title="Link target outside of Sample">Chapter 53</span>
<ol class="toc">
<li id="toc-li-110">
<span href="#/text/ch054#new-york-new-york-5" title="Link target outside of Sample">New York, New York</span>
</li>
</ol>
</li>
<li id="toc-li-111">
<span href="#/text/ch055#chapter-54" title="Link target outside of Sample">Chapter 54</span>
<ol class="toc">
<li id="toc-li-112">
<span href="#/text/ch055#boston-massachusetts-1" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-113">
<span href="#/text/ch056#chapter-55" title="Link target outside of Sample">Chapter 55</span>
<ol class="toc">
<li id="toc-li-114">
<span href="#/text/ch056#new-york-new-york-6" title="Link target outside of Sample">New York, New York</span>
</li>
</ol>
</li>
<li id="toc-li-115">
<span href="#/text/ch057#chapter-56" title="Link target outside of Sample">Chapter 56</span>
<ol class="toc">
<li id="toc-li-116">
<span href="#/text/ch057#boston-massachusetts-2" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-117">
<span href="#/text/ch058#chapter-57" title="Link target outside of Sample">Chapter 57</span>
<ol class="toc">
<li id="toc-li-118">
<span href="#/text/ch058#boston-massachusetts-3" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-119">
<span href="#/text/ch059#chapter-58" title="Link target outside of Sample">Chapter 58</span>
<ol class="toc">
<li id="toc-li-120">
<span href="#/text/ch059#boston-massachusetts-4" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-121">
<span href="#/text/ch060#chapter-59" title="Link target outside of Sample">Chapter 59</span>
<ol class="toc">
<li id="toc-li-122">
<span href="#/text/ch060#boston-massachusetts-5" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-123">
<span href="#/text/ch061#chapter-60" title="Link target outside of Sample">Chapter 60</span>
<ol class="toc">
<li id="toc-li-124">
<span href="#/text/ch061#outskirts-of-boston-massachusetts" title="Link target outside of Sample">Outskirts of Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-125">
<span href="#/text/ch062#chapter-61" title="Link target outside of Sample">Chapter 61</span>
<ol class="toc">
<li id="toc-li-126">
<span href="#/text/ch062#boston-massachusetts-6" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-127">
<span href="#/text/ch063#chapter-62" title="Link target outside of Sample">Chapter 62</span>
<ol class="toc">
<li id="toc-li-128">
<span href="#/text/ch063#boston-massachusetts-7" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-129">
<span href="#/text/ch064#chapter-63" title="Link target outside of Sample">Chapter 63</span>
<ol class="toc">
<li id="toc-li-130">
<span href="#/text/ch064#boston-massachusetts-8" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-131">
<span href="#/text/ch065#chapter-64" title="Link target outside of Sample">Chapter 64</span>
<ol class="toc">
<li id="toc-li-132">
<span href="#/text/ch065#boston-massachusetts-9" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-133">
<span href="#/text/ch066#chapter-65" title="Link target outside of Sample">Chapter 65</span>
<ol class="toc">
<li id="toc-li-134">
<span href="#/text/ch066#boston-massachusetts-10" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-135">
<span href="#/text/ch067#chapter-66" title="Link target outside of Sample">Chapter 66</span>
<ol class="toc">
<li id="toc-li-136">
<span href="#/text/ch067#boston-massachusetts-11" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-137">
<span href="#/text/ch068#chapter-67" title="Link target outside of Sample">Chapter 67</span>
<ol class="toc">
<li id="toc-li-138">
<span href="#/text/ch068#boston-massachusetts-12" title="Link target outside of Sample">Boston, Massachusetts</span>
</li>
</ol>
</li>
<li id="toc-li-139">
<span href="#/text/ch069#chapter-68" title="Link target outside of Sample">Chapter 68</span>
<ol class="toc">
<li id="toc-li-140">
<span href="#/text/ch069#islamabad-islamic-republic-of-pakistan" title="Link target outside of Sample">Islamabad, Islamic Republic of Pakistan</span>
</li>
</ol>
</li>
<li id="toc-li-141">
<span href="#/text/ch070#authors-note" title="Link target outside of Sample">Author’s note</span>
<ol class="toc">
<li id="toc-li-142">
<span href="#/text/ch070#isis-and-daesh" title="Link target outside of Sample">ISIS and Daesh</span>
</li>
<li id="toc-li-143">
<span href="#/text/ch070#the-doughnut-echelon-and-the-web-based-email-loophole" title="Link target outside of Sample">The Doughnut, Echelon and the web-based email loophole</span>
</li>
<li id="toc-li-144">
<span href="#/text/ch070#bhopal" title="Link target outside of Sample">Bhopal</span>
</li>
<li id="toc-li-145">
<span href="#/text/ch070#satellite-surveillance" title="Link target outside of Sample">Satellite surveillance</span>
</li>
</ol>
</li>
<li id="toc-li-146">
<span href="#/text/ch071#an-agent-paul-richter-thriller" title="Link target outside of Sample">An Agent Paul Richter Thriller</span>
</li>
<li class="author_bio">
<span href="#/text/author_bio" title="Link target outside of Sample">About the Author</span>
</li>
<li class="also_by">
<span href="#/text/also_by" title="Link target outside of Sample">Also by James Barrington</span>
</li>
<li id="toc-li-147">
<span href="#/text/ch072#copyright" title="Link target outside of Sample">Copyright</span>
</li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<ol>
<li>
<span epub:type="cover" href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li>
<a epub:type="toc" href="#/nav#toc">Table of Contents</a>
</li>
<li>
<a epub:type="bodymatter" href="#/text/title_page">Start of Content</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?bc079d6c